module.exports = __webpack_public_path__ + "static/media/real7.bc91df9f.jpg";